import React, { useRef } from "react";
import { Link } from "@fluentui/react-components";

const ImagePicker = ({ label = "Choose icon", accept = "image/*", onFileSelected, fileInputRef, className }) => {
  const internalRef = useRef(null);
  const inputRef = fileInputRef || internalRef;

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelected(file);
    }
  };

  return (
    <>
      <input type="file" ref={inputRef} style={{ display: "none" }} accept={accept} onChange={handleChange} />
      <Link onClick={handleClick} className={className}>
        {label}
      </Link>
    </>
  );
};

export default ImagePicker;
